<form style="background-color: #f1f1f1">
    <div style="margin-bottom: 60px;"><a class="navbar-brand logoLink"
        ><img src="./assets/img/TVS_Credit_logo.png" alt="logo" class=""
      /></a></div>
  <div class="container">
    <label for="agreementNumbers"><b>Agreement Numbers :</b></label>
    <textarea
      placeholder="Enter Agreement Numbers"
      name=" agreementData"
      [(ngModel)]="agreementData" style=" font-family: 'Figtree', sans-serif !important"
    ></textarea>
    <div class="container">
      <button type="button" class="clearbtn" (click)="clearData()">
        Clear
      </button>
      <button type="button" class="submitbtn" (click)="submitData()">
        Submit
      </button>
    </div>
  </div>
</form>
<div *ngIf=showData class="tenure-box mt-3 mb-3 formData"  >
  <table class="table" >
    <tbody>
        <tr>
         <th *ngFor='let key of arrayOfKeys'>{{key}}</th>
        </tr>
      <tr
          class="mt-3"
          style="width: 100%; margin-bottom: 15px"
          *ngFor="let data of emandataList"
        >
          <td style="font-variant: lining-nums;">
            {{ data.CUST_ID }}
          </td>
          <td style="font-variant: lining-nums;">
            {{ data.AUTHORISED }}
          </td>
          <td style="font-variant: lining-nums;">
            {{ data.AGGREMENT_NO }}
          </td>
          <td style="font-variant: lining-nums;">
            {{ data.EMANDATE_UMRM }}
          </td>
          <td style="font-variant: lining-nums;">
            {{ data.EMANDATE_COMPLETED_DATE }}
          </td>
          <td style="font-variant: lining-nums;">
            {{ data.EMAN_ENABLED_FLOW }}
          </td>
        </tr>

    </tbody>
  </table>
</div>
<loader *ngIf="loader"></loader>

